import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { MARKETING_NAMES, prefix } from './utils/form';

export const MarketingPlan: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.MARKETING_PLAN,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('marketingAndSales.title')}
          badgeText={t('marketingAndSales.marketing.title')}
          section={FOR_BANK_SECTIONS.MARKETING_AND_SALES}
        />
      </FormSectionCard>
      {/* 5.2.1 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.advertisingCampaigns')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.ADVERTISING_CAMPAIGNS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.ADVERTISING_CAMPAIGNS)}
          name={concatWithDot(prefix, MARKETING_NAMES.ADVERTISING_CAMPAIGNS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 5.2.2 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.budget')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.BUDGET)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.BUDGET)}
          name={concatWithDot(prefix, MARKETING_NAMES.BUDGET)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 5.2.3 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.brandElements')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.BRAND_ELEMENTS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.BRAND_ELEMENTS)}
          name={concatWithDot(prefix, MARKETING_NAMES.BRAND_ELEMENTS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 5.2.4 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.positioning')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.POSITIONING)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.POSITIONING)}
          name={concatWithDot(prefix, MARKETING_NAMES.POSITIONING)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 5.2.5 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.pricingStrategy')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.PRICING_STRATEGY)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.PRICING_STRATEGY)}
          name={concatWithDot(prefix, MARKETING_NAMES.PRICING_STRATEGY)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 5.2.6 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.toolsAndTechnologies')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.TOOLS_AND_TECHNOLOGIES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.TOOLS_AND_TECHNOLOGIES)}
          name={concatWithDot(prefix, MARKETING_NAMES.TOOLS_AND_TECHNOLOGIES)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
